import { Badge, Box, Grid2, styled, Typography } from "@mui/material";
import { KPIBoxCustomWidth } from "./CustomBox";
import { ThemeProperties } from "../Theme/ThemeProperties";
import zIndex from "@mui/material/styles/zIndex";


const DateItemContainer = styled(Box)(({ shouldHighlight, shouldHighlightDataGap }) => ({
    backgroundColor: ThemeProperties.white,
    borderRadius: "4px",
    padding: "5px 17px",
    width: "max-content",
    cursor: "pointer",
    marginBottom: "10px",
    marginTop: "10px",
    mt: 0,
    backgroundColor: shouldHighlightDataGap ? "#FFF1F1" : shouldHighlight ? "#F7F7FF" : "",
    boxShadow:
        shouldHighlight
            ? "0px 4px 4px 0px rgba(151, 151, 151, 0.25)"
            : "",

    border:
        shouldHighlight
            ? "2px solid #8F93FF"
            : "2px solid #C8D1DA",

    "&:hover": {
        border: `2px solid #8F93FF`,
    },
}));


export const AnnotateDate = styled(Badge)(({ theme, color }) => ({
    "& .MuiBadge-badge": {
        backgroundColor: color,
        color: color,
        width: "9px",
        height: "9px",
        minWidth: "9px",
        borderRadius: "50%",
        top: '10px',
        right: '2px'
    },
}));


const ChartCarouselDateItem = ({
    shouldHighlight,
    actualDate,
    startDate,
    onClick,
    text,
    annotate = {},
    shouldHighlightDataGap = false
}) => {

    const shouldAnnotate = annotate.shouldAnnotate
    const annotateColor = annotate.annotateColor

    return (

        <AnnotateDate
            variant="dot"
            overlap="circular"
            invisible={!shouldAnnotate}
            color={annotateColor}
        >
            <DateItemContainer
                onClick={() => { onClick(actualDate) }}
                shouldHighlight={shouldHighlight}
                shouldHighlightDataGap={shouldHighlightDataGap}
            >
                <Typography variant={shouldHighlight ? "fw500s12lh24c444B51" : "fw500s12lh24c686868"}>
                    {text}
                </Typography>
            </DateItemContainer>
        </AnnotateDate>
    )
}

export default ChartCarouselDateItem;